import { useStore } from '@/store/store';
import { useDatafeeds } from '@/logics/datafeed';
import { languageToCode } from '@/logics/utils';
const THEME_DARK = 'Dark';
export const useWidget = () => {
    const store = useStore();
    const getWidgetColor = (theme) => ({
        positiveColor: theme === THEME_DARK ? '#00a969' : '#10c673',
        negativeColor: theme === THEME_DARK ? '#ff8dbe' : '#ff0000',
    });
    const getWidgetOverrides = (theme) => {
        const { positiveColor, negativeColor } = getWidgetColor(theme);
        return {
            'mainSeriesProperties.lineStyle.color': positiveColor,
            'mainSeriesProperties.candleStyle.upColor': positiveColor,
            'mainSeriesProperties.candleStyle.downColor': negativeColor,
            'mainSeriesProperties.candleStyle.borderColor': positiveColor,
            'mainSeriesProperties.candleStyle.borderUpColor': positiveColor,
            'mainSeriesProperties.candleStyle.borderDownColor': negativeColor,
            'mainSeriesProperties.candleStyle.wickUpColor': positiveColor,
            'mainSeriesProperties.candleStyle.wickDownColor': negativeColor,
            'mainSeriesProperties.barStyle.upColor': positiveColor,
            'mainSeriesProperties.barStyle.downColor': negativeColor,
            'mainSeriesProperties.hollowCandleStyle.borderColor': positiveColor,
            'mainSeriesProperties.hollowCandleStyle.borderUpColor': positiveColor,
            'mainSeriesProperties.hollowCandleStyle.borderDownColor': negativeColor,
            'mainSeriesProperties.hollowCandleStyle.upColor': positiveColor,
            'mainSeriesProperties.hollowCandleStyle.downColor': negativeColor,
            'mainSeriesProperties.hollowCandleStyle.wickUpColor': positiveColor,
            'mainSeriesProperties.hollowCandleStyle.wickDownColor': negativeColor,
            'mainSeriesProperties.haStyle.upColor': positiveColor,
            'mainSeriesProperties.haStyle.downColor': negativeColor,
            'mainSeriesProperties.haStyle.borderColor': positiveColor,
            'mainSeriesProperties.haStyle.borderUpColor': positiveColor,
            'mainSeriesProperties.haStyle.borderDownColor': negativeColor,
            'mainSeriesProperties.haStyle.wickUpColor': positiveColor,
            'mainSeriesProperties.haStyle.wickDownColor': negativeColor,
        };
    };
    const base = store.state.symbol.base;
    const getWidgetOptions = (pair, containerId, libraryPath) => {
        const { positiveColor, negativeColor } = getWidgetColor(store.state.theme);
        const overrides = getWidgetOverrides(store.state.theme);
        const { datafeeds } = useDatafeeds(pair, base, store.state.currencyInfo, store.state.currencyPairInfo);
        const widgetOptions = {
            debug: false,
            width: '100%',
            height: !store.state.chart.isFull ? 316 : window.innerHeight - 38,
            symbol: pair,
            datafeed: datafeeds,
            timezone: store.state.userSettings.localTime,
            interval: store.getters.chartInterval,
            container: containerId,
            library_path: libraryPath,
            locale: languageToCode(String(store.state.userSettings.language)),
            fullscreen: false,
            disabled_features: ['header_symbol_search', 'header_fullscreen_button', 'header_compare', 'left_toolbar'],
            theme: store.getters.theme,
            studies_overrides: {
                'volume.volume.color.0': positiveColor,
                'volume.volume.color.1': negativeColor,
            },
            overrides,
        };
        return widgetOptions;
    };
    return { getWidgetOptions, getWidgetColor, getWidgetOverrides };
};
